import React, { ReactElement, useState } from 'react';
import * as _ from 'lodash';
import classnames from 'classnames';
import styles from './simpleInput.module.scss';

export interface SimpleInputProps extends React.HTMLProps<HTMLInputElement> {
    inputName: string;
    labelText?: string;
    ariaLabelText?: string;
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    groupClassName?: string;
    inputFieldClassName?: string;
    inputContainerClassName?: string;
    errors?: string[];
    onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    highlightError?: boolean;
    highlightGroupError?: boolean;
}

function SimpleInput({
    inputName,
    labelText,
    ariaLabelText,
    value,
    onChange,
    groupClassName,
    inputFieldClassName,
    inputContainerClassName,
    maxLength,
    errors,
    onKeyPress,
    highlightError,
    highlightGroupError,
    ...inputProps
}: SimpleInputProps): ReactElement {
    const [uniqueId] = useState(_.uniqueId(`${inputName}-`));
    const [uniqueHintId] = useState(_.uniqueId(`${inputName}Hint-`));

    const formInputClasses = classnames(
        { [styles.inputGroupErrorHighlight]: (!_.isEmpty(errors) || highlightError) && highlightGroupError },
        styles.inputGroup,
        groupClassName
    );

    return (
        <div className={formInputClasses}>
            {labelText && (
                <label className={styles.inputLabel} htmlFor={uniqueId}>
                    {labelText}
                </label>
            )}
            <div className={inputContainerClassName}>
                <input
                    className={classnames(
                        { [styles.inputError]: !_.isEmpty(errors) || highlightError },
                        styles.inputField,
                        inputFieldClassName
                    )}
                    id={uniqueId}
                    aria-describedby={uniqueHintId}
                    aria-label={ariaLabelText}
                    type='text'
                    name={inputName}
                    value={value}
                    maxLength={maxLength}
                    onChange={(event): void => {
                        event.preventDefault();
                        onChange(event);
                    }}
                    onKeyPress={(event: React.KeyboardEvent<HTMLInputElement>): void => {
                        if (onKeyPress) onKeyPress(event);
                    }}
                    {...inputProps}
                />
            </div>
        </div>
    );
}

export default SimpleInput;
